import React from 'react'

const DocumentUploaded = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path
            d="M19.2001 8.03922L18.3601 7.19922L9.60005 15.9592L5.64005 11.9992L4.80005 12.8392L9.60005 17.6392L19.2001 8.03922Z"
            fill="#008200"
        />
    </svg>
)

export default DocumentUploaded
